// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"e50b3e7fc44554bc8749","883":"4003edf13e4a394f6224"}[chunkId] + ".js";
};